import React from "react";
import { IconButton } from "@components/atoms/buttons/icon-button/icon-button";
import { useControlBarDeleteButtonHook } from "./use-control-bar-delete-node-button-hook";
import { useI18N } from "@src/language/language-context";

export const ControlBarDeleteButton = () => {
  const { icon, disabled, deleteNodesFromNodeset } =
    useControlBarDeleteButtonHook();
  const i18n = useI18N();
  const tooltip = i18n("modules.machineStructurePanelControlBar.delete");

  return (
    <IconButton
      key={tooltip}
      tooltip={tooltip}
      tooltipPosition="bottom"
      fun={deleteNodesFromNodeset}
      icon={icon}
      disabled={disabled}
    />
  );
};
